import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

const HappyToHelp = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        <Card className="shadow-lg border-0 rounded-4 overflow-hidden mb-4">
          <div className="bg-gradient-primary p-4 text-white d-flex align-items-center justify-content-between">
            <div>
              <h2 className="text-white mb-0 mt-1 font-weight-700" style={{ fontSize: isSmallScreen ? "18px" : "24px" }}>
                Happy to Help
              </h2>
            </div>
            <div className="d-none d-md-block">
              <span className="badge badge-pill font-weight-bold py-2 px-3" style={{ backgroundColor: "#ffffff", color: "#5e72e4" }}>
                FansHelpPlayers.com
              </span>
            </div>
          </div>

          <CardBody className="p-4" style={{ backgroundColor: "#f8fafc" }}>
            <Row className="justify-content-center">
              <Col lg="10" xl="8">
                <div className="text-center mb-4">
                  <p className="text-muted" style={{ fontSize: "1rem", lineHeight: "1.6" }}>
                    Watch this comprehensive walkthrough video to learn how you can use our platform tools to connect with fans, showcase your sports experience, and maximize your athlete profile.
                  </p>
                </div>

                {/* Responsive Embedded YouTube Player */}
                <div
                  className="shadow-md rounded-lg overflow-hidden position-relative mb-4 bg-dark"
                  style={{
                    paddingTop: "56.25%", /* 16:9 Aspect Ratio */
                    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
                    borderRadius: "16px"
                  }}
                >
                  <iframe
                    className="position-absolute top-0 start-0 w-100 h-100 border-0"
                    style={{ left: 0, top: 0 }}
                    src="https://www.youtube.com/embed/oLTEAYipCB0"
                    title="FansHelpPlayers.com - Happy to Help Explainer Video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>

                <div className="d-flex flex-wrap justify-content-center gap-3 mt-3 align-items-center">
                  <span className="text-muted mr-2" style={{ fontSize: "0.875rem" }}>
                    Can't view the video?
                  </span>
                  <a
                    href="https://youtu.be/oLTEAYipCB0"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary btn-sm rounded-pill font-weight-600 px-4"
                  >
                    <i className="fab fa-youtube mr-2"></i> Watch on YouTube
                  </a>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default HappyToHelp;
